export default "__VITE_ASSET__DuEAEkUQ__"